// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"806e5643","453":"e82ace9d","891":"b7237944","947":"5de6509d"}[chunkId] + ".chunk.js";
};